module.exports = __webpack_public_path__ + "main/assets/public/event/icon-map.06066059b5afc69b.svg";